import { displayOverallStatusLabel } from "./overall-status.utils"

/**
 * Returns Tailwind classes for a muted status button, matching the
 * Overall Status color logic used in Home Details (completion-status-display).
 * Use for Overall Status buttons in the HO filter/search table and mobile cards.
 * Muted palette: light background (100), subtle border (300), dark text (800).
 */
export function getStatusButtonClass(status: string | null | undefined): string {
  switch (displayOverallStatusLabel(status)) {
    case "No Assistance Required":
    case "Complete":
    case "Materials Only Complete":
    case "HOR":
    case "Demo":
      return "bg-green-100 border border-green-300 text-green-800 hover:bg-green-200"
    case "In Progress":
      return "bg-yellow-100 border border-yellow-300 text-yellow-800 hover:bg-yellow-200"
    case "Materials Only":
      return "bg-amber-100 border border-amber-300 text-amber-800 hover:bg-amber-200"
    case "Functionally Complete":
      return "bg-orange-100 border border-orange-300 text-orange-800 hover:bg-orange-200"
    case "Not Started":
      return "bg-gray-100 border border-gray-300 text-gray-800 hover:bg-gray-200"
    default:
      return "bg-slate-100 border border-slate-300 text-slate-800 hover:bg-slate-200"
  }
}

/**
 * Tailwind classes for Goodwill Status buttons (table column).
 * Matches GoodwillHomeStatusDisplay: grey Not Started/Unknown, yellow In Progress, green Complete/No Assistance Required.
 */
export function getGoodwillStatusButtonClass(status: string | null | undefined): string {
  switch (status) {
    case "Not Started":
    case "Unknown":
      return "bg-gray-100 border border-gray-300 text-gray-800 hover:bg-gray-200"
    case "In Progress":
      return "bg-yellow-100 border border-yellow-300 text-yellow-800 hover:bg-yellow-200"
    case "Complete":
    case "No Assistance Required":
      return "bg-green-100 border border-green-300 text-green-800 hover:bg-green-200"
    default:
      return "bg-slate-100 border border-slate-300 text-slate-800 hover:bg-slate-200"
  }
}
